import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMicrosoftAuth } from "../../context/MicrosoftAuthContext";
import { useLayout } from "../../context/LayoutContext";
import { useTheme } from "../../context/ThemeContext";

const Topbar = () => {
  const { isAuthenticated, user, logout, sessionTimeout } = useMicrosoftAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { isSidebarCollapsed, toggleSidebar, expandedWidth, collapsedWidth, isMobile, toggleMobileMenu } = useLayout();
  const { isDark, toggleTheme } = useTheme();

  const handleLogout = () => {
    logout();
  };

  const handleSessionTimeout = () => {
    sessionTimeout();
  };


  const pathname = location.pathname || "/";
  const getTitleFromPath = (path) => {
    if (path === "/" || path === "/dashboard") return "Dashboard";
    if (path.startsWith("/Submissionprogress")) return "New Submission";
    if (path === "/submission") return "Submissions";
    if (path.startsWith("/submissions/")) return "Submission Details";
    if (path.startsWith("/submission-logs/")) return "Submission Logs";
    if (path.startsWith("/docs/")) return "Documents";
    if (path === "/login") return "Login";
    return "Dashboard";
  };
  const pageTitle = getTitleFromPath(pathname);

  const sidebarWidth = isSidebarCollapsed ? collapsedWidth : expandedWidth;

  return (
    <div
      className="flex items-center gap-[10px] p-[16px] fixed top-0 right-0 z-20 transition-colors duration-200"
      style={{
        left: isMobile ? '0' : `${sidebarWidth}px`,
        backgroundColor: isDark ? '#161515' : '#ffffff',
        borderBottom: isDark ? '1px solid #292929' : 'none'
      }}
    >
      {/* Burger Menu */}
      <button
        onClick={isMobile ? toggleMobileMenu : toggleSidebar}
        className="shrink-0 bg-transparent border-0 cursor-pointer p-0"
        aria-label="Menu"
        aria-pressed={isMobile ? false : isSidebarCollapsed}
      >
        <span
          className="flex items-center justify-center w-[32px] h-[32px] rounded-[10px] transition-colors duration-200"
          style={{
            backgroundColor: !isMobile && isSidebarCollapsed
              ? (isDark ? '#292929' : '#F9D6D5')
              : 'transparent'
          }}
        >
          <div
            className="w-[18px] h-[18px] transition-colors duration-200"
            style={{
              backgroundColor: isDark ? '#ffffff' : '#072837',
              WebkitMaskImage: 'url(/assets/icons/burgermenu.svg)',
              WebkitMaskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskImage: 'url(/assets/icons/burgermenu.svg)',
              maskSize: 'contain',
              maskRepeat: 'no-repeat',
              maskPosition: 'center'
            }}
          />
        </span>
      </button>

      {/* Page Title */}
      <h1
        className="text-[16px] font-semibold flex-1 m-0 leading-normal transition-colors duration-200"
        style={{ color: isDark ? '#ffffff' : '#072837' }}
      >
        {pageTitle}
      </h1>

      {/* Light/Dark Mode Toggle */}
      <button
        onClick={toggleTheme}
        className="shrink-0 w-[44px] h-[24px] border rounded-[999px] relative cursor-pointer transition-colors"
        style={{
          backgroundColor: isDark ? '#161515' : '#ffffff',
          borderColor: isDark ? '#334e5e' : '#cbd5e1'
        }}
        aria-label="Toggle theme"
        aria-pressed={isDark}
      >
        <span
          className={`absolute top-1/2 -translate-y-1/2 w-[18px] h-[18px] flex items-center justify-center transition-all ${
            isDark ? 'left-[3px]' : 'right-[3px]'
          }`}
        >
          <div
            className="w-[14px] h-[14px] pointer-events-none transition-colors duration-200"
            style={{
              backgroundColor: isDark ? '#ffffff' : '#072837',
              WebkitMaskImage: `url(${isDark ? "/assets/icons/darkmode.svg" : "/assets/icons/lightmode.svg"})`,
              WebkitMaskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskImage: `url(${isDark ? "/assets/icons/darkmode.svg" : "/assets/icons/lightmode.svg"})`,
              maskSize: 'contain',
              maskRepeat: 'no-repeat',
              maskPosition: 'center'
            }}
          />
        </span>
      </button>

      {/* Logout Section */}
      {isAuthenticated && (
        <div className="flex items-center gap-[10px] shrink-0">
          {!user ? (
            handleSessionTimeout()
          ) : null}
          <button
            onClick={handleLogout}
            className="flex items-center gap-[10px] bg-transparent border-0 cursor-pointer p-0"
          >
            <div
              className="w-[24px] h-[24px] transition-colors duration-200"
              style={{
                backgroundColor: isDark ? '#ffffff' : '#072837',
                WebkitMaskImage: 'url(/assets/icons/logout.svg)',
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskImage: 'url(/assets/icons/logout.svg)',
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center'
              }}
            />
            <span
              className="text-[16px] font-medium leading-normal transition-colors duration-200"
              style={{ color: isDark ? '#ffffff' : '#072837' }}
            >
              Logout
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Topbar;
